import styled from 'styled-components';
import { Monospace2, body2, borderRadius, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Code = styled(Monospace2)`
  font-size: ${pxToRem(13)};
  background-color: unset;
  padding: unset;

  &[data-secondarystyle='true'] {
    color: ${colors.textSecondary};
  }
`;

export const Body = styled.button`
  all: revert;
  ${body2}
  display: inline-flex;
  cursor: pointer;
  gap: 1ch;
  padding: 0.5ch;
  align-items: center;
  background-color: ${colors.grey10};
  border: ${spacing.single} solid transparent;
  border-radius: ${borderRadius.md};
  outline-offset: ${spacing.single};
  height: ${spacing.plusHalf};

  &:hover {
    border-color: ${colors.grey15};
  }
  &:focus {
    outline: ${spacing.eighth} solid ${colors.purple50};
  }

  &[data-fillheight='true'] {
    height: 100%;
    min-height: ${spacing.plusHalf};
    max-height: ${spacing.doubleHalf};
  }
`;

export const SvgContainer = styled.div`
  height: ${spacing.plusQuarter};
  align-self: center;
`;
